import { render, staticRenderFns } from "./onlineBianti.vue?vue&type=template&id=e29930b4&scoped=true&"
import script from "./onlineBianti.vue?vue&type=script&lang=js&"
export * from "./onlineBianti.vue?vue&type=script&lang=js&"
import style0 from "./onlineBianti.vue?vue&type=style&index=0&id=e29930b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e29930b4",
  null
  
)

export default component.exports